module.exports = __webpack_public_path__ + "img/bell-school-slash.62dd5d37.svg";